import { useMemo } from 'react';
import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';
import { useSession } from 'src/contexts/SessionContext';
interface PaymentTypeFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

export const PaymentTypeFilter: React.FC<PaymentTypeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];
  const { session } = useSession();

  const paymentTypes = useMemo(() => {
    const paymentTypes = [
      { id: 'cash', name: 'Cash' },
      { id: 'check', name: 'Check' },
      { id: 'card', name: 'Card' },
      { id: 'other', name: 'Other' },
      { id: 'bank', name: 'Bank Transfer' },
    ];

    if (session?.otherPaymentMethodLabels) {
      paymentTypes.push(
        ...session.otherPaymentMethodLabels.map((label) => ({
          id: label,
          name: label,
        }))
      );
    }

    return paymentTypes;
  }, [session?.otherPaymentMethodLabels]);

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) => paymentTypes.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) => paymentTypes.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={paymentTypes}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? paymentTypes.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Payment Type"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
